import {Pages} from "./pages";
import {ListSortOrder} from "./list-sort-order";

export class PagedFilter<T> {
  constructor(private pages: Pages, public filter: T, public order?: ListSortOrder, private raceId?: number,) {
  }
}
